import * as React from "react";

const Kayla = () => {
  return (
    <ol className="references">
     <li>
     My Sistah’s House Memphis. Home. Accessed March 15, 2022.&nbsp;
      <a target="_blank" className="" href="https://mshmemphis.org">https://mshmemphis.org</a>
      </li>
      <li>
      My Sistah’s House Memphis. About Us. Accessed March 15, 2022.&nbsp;
        <a target="_blank" className="" href="https://mshmemphis.org/about-us-1">https://mshmemphis.org/about-us-1</a>
      </li>
      <li>
      James SE, Herman JL, Rankin S, Keisling M, Mottet L, Anafi M. <em>The report of the 2015 U.S. Transgender Survey.</em> Washington, DC: National Center for Transgender Equality. Published December 2016. Accessed March 15, 2022.&nbsp;
        <a target="_blank" className="" href="https://transequality.org/sites/default/files/docs/usts/USTS-Full-Report-Dec17.pdf">https://transequality.org/sites/default/files/docs/usts/USTS-Full-Report-Dec17.pdf</a>
      </li>
      <li>
      James SE, Brown C, Wilson I. <em>2015 U.S. Transgender Survey: Report on the Experiences of Black Respondents. Washington,</em> DC and Dallas, TX: National Center for Transgender Equality, Black Trans Advocacy, and National Black Justice Coalition. Published September 2017. Accessed March 15, 2022.&nbsp;
        <a target="_blank" className="" href="https://transequality.org/sites/default/files/docs/usts/USTS-Black-Respondents-Report.pdf">https://transequality.org/sites/default/files/docs/usts/USTS-Black-Respondents-Report.pdf</a>
      </li>
      <li>
      National Center for Transgender Equality. Issues: Housing and Homelessness. Accessed March 15, 2022.&nbsp;
        <a target="_blank" className="" href="https://transequality.org/issues/housing-homelessness">https://transequality.org/issues/housing-homelessness</a>
      </li>
      <li>
      Human Rights Campaign. Transgender people and HIV: what we know. Accessed July 30, 2021.&nbsp;
      <a target="_blank" className="" href="https://www.hrc.org/resources/transgender-people-and-hiv-what-we-know">https://www.hrc.org/resources/transgender-people-and-hiv-what-we-know</a>

      </li>
      <li>
      Centers for Disease Control and Prevention. HIV infection, risk, prevention, and testing behaviors among transgender women—National HIV Behavioral Surveillance, 7 U.S. Cities, 2019&ndash;2020. <em>HIV Surveillance Special Report.</em> 2021;27. Published April 2021. Accessed March 15, 2022.&nbsp;
      <a target="_blank" className="" href="https://www.cdc.gov/hiv/pdf/library/reports/surveillance/cdc-hiv-surveillance-special-report-number-27.pdf">https://www.cdc.gov/hiv/pdf/library/reports/surveillance/cdc-hiv-surveillance-special-report-number-27.pdf</a>
      </li>
     
      <li>
        Aidala AA, Wilson MG, Shubert V, et al. Housing status, medical care, and health outcomes among people living with HIV/AIDS: a systematic review. <em>Am J Public Health.</em> 2016;106(1):e1-e23.        
      </li>
      <li>
      HIV.gov. Housing and Health. Updated August 21, 2019. Accessed March 15, 2022.&nbsp;
      <a target="_blank" className="" href="https://www.hiv.gov/hiv-basics/living-well-with-hiv/taking-care-of-yourself/housing-and-health">https://www.hiv.gov/hiv-basics/living-well-with-hiv/taking-care-of-yourself/housing-and-health</a>
      </li>
      <li>
      The White House Office of National AIDS Policy. <em>National HIV/AIDS Strategy for the United States 2022&ndash;2025.</em> Washington, DC. Published 2021. Accessed March 15, 2022.&nbsp;
      <a target="_blank" className="" href="https://www.whitehouse.gov/wp-content/uploads/2021/11/National-HIV-AIDS-Strategy.pdf">https://www.whitehouse.gov/wp-content/uploads/2021/11/National-HIV-AIDS-Strategy.pdf</a>

      </li>
      <li>
      US Department of Housing and Urban Development. HUD withdraws proposed rule, reaffirms its commitment to equal access to housing, shelters, and other services regardless of gender identity. Press release HUD No. 21-069. Washington, DC. Published April 22, 2021. Accessed March 15, 2022.&nbsp;
      <a target="_blank" className="" href="https://www.hud.gov/press/press_releases_media_advisories/HUD_No_21_069">https://www.hud.gov/press/press_releases_media_advisories/HUD_No_21_069</a>

      </li>
      <li>
      GoFundMe. 20 tiny homes for trans women: Updates. Updated March 7, 2022. Accessed March 15, 2022.&nbsp;<br class="desktop"/>       
      <a target="_blank" className="" href="https://www.gofundme.com/f/mshmemphis">https://www.gofundme.com/f/mshmemphis</a>

      </li>
      
      <li>
      Centers for Disease Control and Prevention. HIV treatment. Reviewed May 20, 2021. Accessed March 15, 2022.&nbsp;<br class="desktop"/>   
        <a target="_blank" className="" href="https://www.cdc.gov/hiv/basics/livingwithhiv/treatment.html">https://www.cdc.gov/hiv/basics/livingwithhiv/treatment.html</a>
      </li>
     
    </ol>
  )
  }

export default Kayla;